import { render, staticRenderFns } from "./LiveBidComponent.vue?vue&type=template&id=1821d9d3"
import script from "./LiveBidComponent.vue?vue&type=script&lang=js"
export * from "./LiveBidComponent.vue?vue&type=script&lang=js"
import style0 from "./LiveBidComponent.vue?vue&type=style&index=0&id=1821d9d3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports